import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { getColor } from 'common/constants/_colors';
import { calculatePercentage } from 'common/utils/utils';
import { Flex } from './base/layout-components';
import Text from './base/Text';

const SECTION_COLORS = ['torchRed', 'orangePeel', 'malachite'];

const Arrow = styled.div`
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 10px 5px 0 5px;
  border-color: #000000 transparent transparent transparent;
  top: -2px;
  ${({ offset }) => (offset ? `left: ${offset}` : ``)};
  transform: translateX(-50%);
`;

const Section = styled.div`
  position: absolute;
  width: calc(100% / 3);
  height: 100%;
  border-radius: 4px;
  ${({ section }) => (section ? `left: calc(${(100 / 3) * section}%)` : ``)};
  ${({ background }) =>
    background ? `background-color: ${getColor(background)}` : ``};
`;

const Rail = styled.div`
  width: 100%;
  position: relative;
  background-color: ${getColor('silver')};
  border-radius: 4px;
  height: 5.55px;
`;

export default class LineGauge extends Component {
  render() {
    const { value, min, max, isReverse } = this.props;
    const percent = Math.max(calculatePercentage(value - min, max - min), 0);
    const section = Math.floor(percent / 33.34);

    const displaySection = isReverse ? 2 - section : section;
    const displayProgress = isReverse ? 100 - percent : percent;

    return (
      <Flex direction='column'>
        <Rail>
          <Section
            background={SECTION_COLORS[displaySection]}
            section={displaySection}
          />
          <Arrow offset={`${displayProgress}%`} />
        </Rail>

        <Flex
          direction={isReverse ? 'row-reverse' : 'row'}
          justify='space-between'
        >
          <Text size='small' color='gray' pt='8px'>
            {min}
          </Text>
          <Text size='small' color='gray' pt='8px'>
            {max}
          </Text>
        </Flex>
      </Flex>
    );
  }
}

LineGauge.propTypes = {
  value: PropTypes.any,
  min: PropTypes.number,
  max: PropTypes.number,
  isReverse: PropTypes.bool
};

LineGauge.defaultProps = {
  value: 0,
  min: 0,
  max: 100,
  isReverse: false
};
